<script lang="ts">
import { computed, PropType, ref } from 'vue'
import { User } from '../../../libs/models'
import UserModal from './UserModal.vue'
import IllustsModal from './IllustsModal.vue'
import UserAlbumsModal from './UserAlbumsModal.vue'
import ReportModal from './ReportModal.vue'
import Loading from './Loading.vue'
import Modal from './Modal.vue'
import { useCurrentUserStore } from '../libs/currentUserStore'
import { useApi } from '../libs/api'
import { useNotificationStore } from '../libs/notificationStore'
import { getApiErrorMessage } from '../libs/apiErrors'
</script>

<script lang="ts" setup>
const emit = defineEmits(['close'])
const props = defineProps({
  user: { required: true, type: [Object, Number] as PropType<User | number> }
})
const currentUserStore = useCurrentUserStore()
const loggedIn = computed(() => !!currentUserStore.value)
const reportable = computed(() => currentUserStore.value?.id !== solvedUser.value?.id)
const modal = ref<null | 'report' | 'illusts' | 'albums'>(null)
const api = useApi()
const notificationStore = useNotificationStore()
const fetchedUser = ref<User>()
const solvedUser = computed(() => typeof props.user === 'number' ? fetchedUser.value : props.user)
if (typeof props.user === 'number') {
  api.get<User>(`/users/${props.user}`).then(({ data }) => {
    fetchedUser.value = data
  }).catch(error => {
    notificationStore.push(getApiErrorMessage(error, 'プロフィールの取得に失敗しました'), 'error')
    emit('close')
  })
}
</script>

<template>
  <Modal v-if="!solvedUser" @close="$emit('close')">
    <div class="ModalContent ProfileLoading">
      <Loading />
    </div>
  </Modal>
  <UserModal :user="solvedUser" v-else-if="!modal" @close="$emit('close')">
    <button @click="modal = 'illusts'"><i class="material-symbols-rounded">image</i>{{ l('イラスト一覧') }}</button>
    <button @click="modal = 'albums'"><i class="material-symbols-rounded">bookmark</i>{{ l('アルバム一覧') }}</button>
    <button class="cancel" @click="$emit('close')">{{ l('閉じる') }}</button>
    <div class="ProfileReport" v-if="loggedIn && reportable">
      <span class="ProfileReport-text" @click="modal = 'report'">
        <i class="material-symbols-rounded">flag</i><span>{{ l('違反報告') }}</span>
      </span>
    </div>
  </UserModal>
  <IllustsModal v-else-if="modal === 'illusts'" :user="solvedUser" @close="modal = null" />
  <UserAlbumsModal v-else-if="modal === 'albums'" :user="solvedUser" @close="modal = null" />
  <ReportModal v-else-if="modal === 'report'" :user="solvedUser" @close="modal = null" />
</template>

<style lang="scss" scoped>
button {
  margin: 10px 0;
}
.ProfileLoading {
  width: 400px;
  min-height: 120px;
  display: grid;
  place-items: center;
}
.ProfileReport {
  margin: 18px 0 3px;
  text-align: center;
  &-text {
    user-select: none;
    cursor: pointer;
  }
  i {
    margin-right: 2px;
    font-size: 18px;
    vertical-align: middle;
  }
  span {
    font-size: 12px;
    vertical-align: middle;
  }
}
</style>
